<ng-container *transloco="let t">

  <h2>{{ t('Report Cards') }} {{ t('for') }} {{month}}</h2>

  <ng-container *ngIf="!reportcards"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

  <p>{{ t('Here are your report cards for') }} {{month}}</p>

  <c-row *ngIf="reportcards">
    <c-col class="col-12 col-md-6 col-lg-4" *ngFor="let workercard of reportcards.workers">
          <img src="{{workercard.img_url}}" class="img-fluid">
    </c-col>
  </c-row>

</ng-container>
